var _path, _rect, _rect2, _rect3, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKeywordIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.432332V2.16211H0V0.432332C0 0.193578 0.186525 0 0.416714 0H19.5831C19.6936 0 19.7997 0.0454646 19.8778 0.126545C19.9559 0.207771 19.9999 0.317663 19.9999 0.432336L20 0.432332ZM15.2082 8.21609C15.5398 8.21609 15.8578 8.07941 16.0921 7.83617C16.3265 7.59293 16.4582 7.26295 16.4582 6.9188C16.4582 6.57478 16.3265 6.2448 16.0921 6.00157C15.8578 5.75819 15.5398 5.6215 15.2082 5.6215C14.8767 5.6215 14.5588 5.75818 14.3244 6.00157C14.0899 6.24482 13.9582 6.57479 13.9582 6.9188C13.9582 7.26296 14.0899 7.59294 14.3244 7.83617C14.5588 8.07941 14.8768 8.21609 15.2082 8.21609ZM0 3.02692H20V15.5677C20 15.6823 19.9561 15.7922 19.8779 15.8735C19.7998 15.9545 19.6938 16 19.5833 16H0.416857C0.186668 16 0.000142779 15.8064 0.000142779 15.5677L0 3.02692ZM13.125 6.9188C13.125 7.49231 13.3444 8.04222 13.7352 8.44775C14.1259 8.85317 14.6558 9.08105 15.2083 9.08105C15.564 9.07946 15.9132 8.981 16.2209 8.79553L17.2043 9.82032L17.2041 9.82046C17.2824 9.90227 17.389 9.94831 17.5 9.94831C17.6111 9.94831 17.7176 9.90227 17.7959 9.82046C17.8747 9.73924 17.9191 9.62876 17.9191 9.51337C17.9191 9.39812 17.8747 9.28765 17.7959 9.20642L16.8542 8.22912C17.1268 7.85601 17.2733 7.40007 17.2708 6.93182C17.2708 6.15938 16.8738 5.44557 16.2292 5.05927C15.5846 4.67312 14.7905 4.67312 14.1458 5.05927C13.5013 5.44557 13.1042 6.15938 13.1042 6.93182L13.125 6.9188ZM1.66679 8.21609H12.5793C12.1962 7.39702 12.1962 6.44073 12.5793 5.6215H1.66679V8.21609Z",
    fill: ""
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.39624,
    y: 6.38147,
    width: 1.07233,
    height: 1.1129,
    fill: ""
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.02307,
    y: 6.38147,
    width: 1.07233,
    height: 1.1129,
    fill: ""
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.65002,
    y: 6.38147,
    width: 1.07233,
    height: 1.1129,
    fill: ""
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.27686,
    y: 6.38147,
    width: 1.07233,
    height: 1.1129,
    fill: ""
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeywordIcon);
export default __webpack_public_path__ + "static/media/keyword-icon.3c7fd58c64a355e22b3cb90bbcc5a2a2.svg";
export { ForwardRef as ReactComponent };